/* eslint-disable react/require-default-props */
import { useRoutes } from '@folklore/routes';
import PropTypes from 'prop-types';
import React from 'react';
import { Route, Switch } from 'wouter';

import MainLayout from './layouts/Main';
import ErrorPage from './pages/Error';
import HomePage from './pages/Home';

import '../styles/styles.css';

const propTypes = {
    apiUrl: PropTypes.string,
};

function Routes({ apiUrl = null }) {
    const routes = useRoutes() || {};
    return (
        <Switch>
            <Route path={routes.home || '/'}>
                <MainLayout>
                    <HomePage path={apiUrl || null} />
                </MainLayout>
            </Route>
            <Route>
                <MainLayout>
                    <ErrorPage />
                </MainLayout>
            </Route>
        </Switch>
    );
}

Routes.propTypes = propTypes;

export default Routes;
